// src/hooks/useUpdatePet.js
import { useMutation, useQueryClient } from "@tanstack/react-query";

const API_URL = import.meta.env.VITE_PAWFRIENDS_API_ENDPOINT_UPDATE_PET || ""; 

async function updatePet({ id, data }) {
  if (!id) throw new Error("Pet ID is required for update");

  console.log("update body in hook", JSON.stringify({ id, ...data }));
  const res = await fetch(`${API_URL}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id, ...data }),  // <-- šaljemo id u body
  });

  if (!res.ok) {
    const errorBody = await res.json();
    throw new Error("Failed to update pet: " + JSON.stringify(errorBody));
  }

  return res.json();
}

export default function useUpdatePet() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePet,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["pets"] });
    }
  });
}
